import { User } from '@uplift/types';
import { restClient } from '../client';
import { ValidationError } from '../errors';
import { ContactName, UserContact, UserContactEmail, UserContactPhone } from '../resources/contacts';
import snakecaseKeys from 'snakecase-keys';


export type ContactsResponse = {
  data: UserContact[];
};

export type ContactPhoneInput = {
  name: ContactName;
  number: string;
};


export const getUserContacts = async (userId: string) =>
  restClient.request<ContactsResponse>(`/api/v1/user/${userId}/contacts`, {
    method: 'GET',
  });


export type RewriteUserContactsInput = {
  phones: Partial<Record<ContactName, string>>;
};

export type RewriteUserContactsErrorResponse = ValidationError<RewriteUserContactsInput>;

export const rewriteUserContacts = (userId: string, data: RewriteUserContactsInput) => restClient.request<ContactsResponse>(`/api/v1/user/${userId}/contacts/phone`, {
  method: 'PUT',
  data: data,
});

export type RewriteUserContactEmailInput = {
  email?: string;
};

export type UpdateUserContactEmailInput = {
  userId: string;
  newEmail: string;
};

export const rewriteUserContactEmail = async (userId: string, data: RewriteUserContactEmailInput) => restClient.request<{
  data: UserContactEmail | null;
}>(`/api/v1/user/${userId}/contacts/email`, {
  method: 'PUT',
  data: data,
});

export const adminUpdateUserEmail = async (data: UpdateUserContactEmailInput) =>
  restClient.request<{ data: User | null }>('/api/v1/admin/update_user_email', {
    method: 'POST',
    data: snakecaseKeys(data),
  });

export type RewriteUserContactByNameErrorResponse = ValidationError<{
  number: string[];
}>;

export const rewriteUserContactByName = async (userId: string, data: ContactPhoneInput) => restClient.request<{
  data: UserContactPhone;
}>(`/api/v1/user/${userId}/contacts/by_name`, {
  method: 'PUT',
  data: data,
});


export const deleteUserContactByName = async (userId: string, name: ContactName) => restClient.request(`/api/v1/user/${userId}/contacts/by_name`, {
  method: 'DELETE',
  data: { name },
});
